module.exports = __webpack_public_path__ + "img/tipos-rodovias.1fc06833.png";